import { Outlet } from 'react-router-dom';
import DashboardLayout from '../../layouts/DashboardLayout';
import { LayoutDashboard, Users, MessageSquare, Link2 } from 'lucide-react';

const mentorMenuItems = [
  {
    title: 'Dashboard',
    to: '/mentor-dashboard',
    icon: <LayoutDashboard className="w-4 h-4" />, 
    end: true,
  },
  {
    title: 'Assign Team',
    to: '/mentor-dashboard/assign-team',
    icon: <Users className="w-4 h-4" />,
  },
  {
    title: 'Idea Feedback',
    to: '/mentor-dashboard/idea-feedback',
    icon: <MessageSquare className="w-4 h-4" />,
  },
  {
    title: 'Team Connect',
    to: '/mentor-dashboard/team-connect',
    icon: <Link2 className="w-4 h-4" />,
  },
];

export function Layout() {
  return (
    <DashboardLayout menuItems={mentorMenuItems}>
      <Outlet />
    </DashboardLayout>
  );
}
